import { useState } from 'react';
import './ReasonDislike.css'


export const ReasonDislike = ({ 
  onClose, 
  onSubmit, 
  recipeId,
  initialReason = '',
  initialCustomReason = '' 
}) => {
  const [selectedReason, setSelectedReason] = useState(initialReason);
  const [customReason, setCustomReason] = useState(initialCustomReason);

  const handleSubmit = () => {
    const finalReason = selectedReason === 'other' ? customReason : selectedReason;
    onSubmit(recipeId, finalReason);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="reason-dislike-container">
      <p>Укажите причину, чтобы исключить рецепт</p>
      
      <div className="dislike-reasons">
        <label className="reason-option">
          <input 
            type="radio" 
            name={recipeId}
            value="taste" 
            checked={selectedReason === 'taste'}
            onChange={(e) => setSelectedReason(e.target.value)}
          />
          <span>Не нравится вкус</span>
        </label>
        
        <label className="reason-option">
          <input 
            type="radio" 
            name={recipeId}
            value="allergy" 
            checked={selectedReason === 'allergy'}
            onChange={(e) => setSelectedReason(e.target.value)}
          />
          <span>Аллергия или непереносимость</span>
        </label>
        
        <label className="reason-option">
          <input 
            type="radio" 
            name={recipeId}
            value="preference" 
            checked={selectedReason === 'preference'}
            onChange={(e) => setSelectedReason(e.target.value)}
          />
          <span>Не ем такие продукты</span>
        </label>
        
        <label className="reason-option">
          <input 
            type="radio" 
            name={recipeId}
            value="other" 
            checked={selectedReason === 'other'}
            onChange={(e) => setSelectedReason(e.target.value)}
          />
          <span>Другая причина</span>
        </label>
        
        {selectedReason === 'other' && (
          <textarea 
            className="other-reason-input"
            placeholder="Укажите свою причину..."
            value={customReason}
            onChange={(e) => setCustomReason(e.target.value)}
            rows={3}
          />
        )}
      </div>
      
      <div className="popup-actions">
        <button 
          className="btn-secondary" 
          onClick={handleClose}
        >
          Отмена
        </button>
        <button 
          className="btn-primary" 
          onClick={handleSubmit}
          disabled={!selectedReason || (selectedReason === 'other' && !customReason.trim())}
        >
          Подтвердить
        </button>
      </div>
    </div>
  );
};